import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=10321871&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=10321871&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10321871",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10321871')) {
      api.createRecord('10321871', component.options)
    } else {
      api.reload('10321871', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=10321871&scoped=true&", function () {
      api.rerender('10321871', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/savideo/Index.vue"
export default component.exports